export const stub = () => {
  // TODO (teamco): Do something.
};

export const detectType = (value: unknown): string => {
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'number') return 'number';

  if (typeof value === 'string') {
    const trimmed = value.trim();

    // Check if it's a number string first to avoid Date.parse catching it
    if (trimmed !== '' && !isNaN(Number(trimmed))) {
      return 'number';
    }

    // Heuristic for date: only try Date.parse if it looks like a date/time
    // (contains -, /, or :) or if it's a valid ISO string.
    // This is to avoid broad false positives like "100%", "2024", or "Number of Tenants: 1" being caught as dates.
    // Also check that it's NOT just a number that Date.parse might interpret as a year.
    if (
      trimmed.length >= 6 &&
      // Strict date-like pattern:
      // YYYY-MM-DD, MM/DD/YYYY, DD-MM-YYYY, etc.
      // or ISO 8601 (YYYY-MM-DDTHH:mm:ss.sssZ)
      // or at least starting with something that looks like a date or time
      (/^(\d{1,4}[-/.]\d{1,2}[-/.]\d{1,4})/.test(trimmed) ||
        /^\d{1,2}:\d{2}/.test(trimmed) ||
        /^\d{4}-\d{2}-\d{2}T/.test(trimmed)) &&
      isNaN(Number(trimmed)) &&
      !/%\s*$/.test(trimmed)
    ) {
      const date = new Date(trimmed);
      if (!isNaN(date.getTime())) {
        return 'date';
      }
    }

    return 'string';
  }

  if (value instanceof Date) return 'date';

  return 'object';
};

export const getKeyFromEnum = <T extends object>(
  enumObj: T,
  value: T[keyof T],
): keyof T | undefined =>
  (Object.keys(enumObj) as Array<keyof T>).find(
    (key) => enumObj[key] === value,
  );
